// Stock crítico del lente de inventario, el que pinta Home VL.
import { useQuery } from '@tanstack/react-query';
import { inventoryLensApi } from '@/api/services/retail-catalog/backoffice';

export const INVENTORY_QUERY_KEY = ['retail-admin', 'inventario'] as const;

/** Prefijo de la lectura de tarjetas PCF; se invalida tras agregar o dar de baja. */
export const CARD_STOCK_QUERY_KEY = [...INVENTORY_QUERY_KEY, 'card-stock'] as const;

/** `?filter=critical` — pares SKU-tienda con menos de 3 piezas. */
export function useInventarioCritical(enabled: boolean) {
    return useQuery({
        queryKey: [...INVENTORY_QUERY_KEY, 'critical'],
        queryFn: () => inventoryLensApi.getCritical(),
        enabled,
        staleTime: 60_000,
    });
}
